module.exports = __webpack_public_path__ + "static/media/mask5.248c1852.svg";